// eslint-disable-next-line no-restricted-imports
import { ActivityDto } from 'api/generated/graphql';
import {
  LegalClientActivity,
  LegalClientActivityEntity,
} from 'api/types/entity';

export const parseLegalClientSaveActivityEntity = (
  data: ActivityDto | undefined
): LegalClientActivityEntity | undefined => {
  if (!data) {
    return undefined;
  }
  return {
    activity: LegalClientActivity[data.activity],
    isLargeEnterprise: data.isLargeEnterprise,
    isNominalHolder: data.isNominalHolder,
    requiresNominalHoldingSubaccount:
      data.isSubAccountRequiredForNominalHolding ?? undefined,
    otherActivity: data.otherActivity ?? undefined,
  };
};
